module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/design-tile-images/design-tile-07-9bc49f93becf25b15a0d6aa164308703.webp";